// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2DSKq","newExpiryDate":"styles_newExpiryDate__1hg4x","footer":"styles_footer___1u4h"};